import request from "@/utils/request";

// 发送验证码
export function sendCode(data) {
  return request({
    url: `/website/send_email_code`,
    method: "get",
    params: data,
  });
}

// 登录 和 注册
export function login(data) {
  return request({
    url: `/website/login`,
    method: "post",
    data: data,
  });
}
